export default "__VITE_ASSET__DJCdUyws__"